// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1j1v_","inner":"Footer_inner__AKViB"};